import i18n from 'i18next';
import LngDetector from 'i18next-browser-languagedetector';

var resBundle = require(
    'i18next-resource-store-loader!../locales/index.js'
);

i18n
    .use(LngDetector)
    .init({
        debug: false, // process.env.NODE_ENV !== 'production',
        resources: resBundle,
        defaultNS: 'common',
        appendNamespaceToMissingKey: true,

        interpolation: {
            escapeValue: false, // not needed for react!!
            prefix: '{',
            suffix: '}',
            defaultVariables: {
                nbsp: '\u00A0', // use unicode for no-break spaces
                shy: '\u00AD' // use unicode for soft hyphens
            }
        },

        // react i18next special options (optional)
        react: {
            wait: false, // set to true if you like to wait for loaded in every translated hoc
            nsMode: 'default' // set it to fallback to let passed namespaces to translated hoc act as fallbacks
        }
    });

export default i18n;


// WEBPACK FOOTER //
// ./src/i18next.js